import Devices from "../Devices/Devices"

const OnlineDevices = () => (
  <Devices
    preset={{ status: "Online" }}
    locked={["status"]}
    title="Online devices"
  />
)

export default OnlineDevices
